module.exports = __webpack_public_path__ + "static/media/Optimized-gallery_table.2d7a0528.jpg";